import { BasePrintAreaCode } from '@gelato-api-ui/core/print-areas/constants/print-area-code';
import { getBaseUid } from '@gelato-api-ui/core/sanity/helpers/getBaseUid';
import { SanityProduct } from '../sanity-product';
import { SanityProductVariation } from '../sanity-product-variation';

export const getAppropriateProductUidByPrintSide = (
  product: SanityProduct,
  productUid: string,
  printSides: BasePrintAreaCode[],
): string => {
  if (!product?.productVariations?.length || !productUid) {
    return null;
  }

  const preparedProductUid = getBaseUid(productUid);
  const sourceProductVariation = product.productVariations.find(v => v.productUid === preparedProductUid);

  if (!sourceProductVariation) {
    return null;
  }

  const appropriateVariation = printSides.reduce<SanityProductVariation>((acc, loopPrintSize) => {
    if (acc) {
      return acc;
    }

    return product.productVariations.find(v => {
      if (
        v.garmentprint === loopPrintSize &&
        v.garmentsize === sourceProductVariation.garmentsize &&
        v.garmentcolor === sourceProductVariation.garmentcolor &&
        v.garmenttechnology === sourceProductVariation.garmenttechnology
      ) {
        return true;
      }

      if (
        v.bagprint === loopPrintSize &&
        v.bagsize === sourceProductVariation.bagsize &&
        v.bagcolor === sourceProductVariation.bagcolor
      ) {
        return true;
      }

      return false;
    });
  }, null);

  return appropriateVariation?.productUid;
};
